export default __webpack_public_path__ + "static/website2-01c09dd306f3efb19fad7153a145cfd1.png";